import React from "react";
import cn from "classnames";
import * as styles from "./styles.module.scss";

const Feature = ({ text, icon, className }) => (
  <div className={cn(styles.container, className)}>
    <img src={icon.image.asset.url} alt={icon.title} className={styles.icon} />
    <span className="b2">{text}</span>
  </div>
);

export default Feature;
